import { render, staticRenderFns } from "./Entrepeneur.vue?vue&type=template&id=4b8330b6&"
import script from "./Entrepeneur.vue?vue&type=script&lang=js&"
export * from "./Entrepeneur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports